import PromoPopup from './PromoPopup';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Landing.css';

const Landing = () => {
  const navigate = useNavigate();
  const [activeFaq, setActiveFaq] = useState(0);
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isCallModalOpen, setIsCallModalOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);

  const phoneNumber = "+34 919 931 923";
  const cleanPhoneNumber = "919931923";

  // Scroll effect for header
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);


  const toggleFaq = (index) => {
    setActiveFaq(activeFaq === index ? -1 : index);
  };

  const handleCopyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(phoneNumber);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Error al copiar:", err);
    }
  };

  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );

  return (
    <div className="landing-container">

      {/* ==================== POPUP NAVIDEÑO ==================== */}
      />

      {/* ==================== BOTÓN FLOTANTE NAVIDAD ==================== */}
      <button 
      >
        🎄 Felicitación Navideña
      </button>

      {/* ==================== HEADER MEJORADO ==================== */}
      <header className={`header-new ${isScrolled ? 'header-scrolled' : ''}`}>
        <div className="header-container">
          <div className="logo">
            <span className="logo-dona">Doña</span>
            <span className="logo-paquita">Paquita</span>
            <span className="beta-badge">Beta</span>
          </div>

          {/* Desktop Navigation */}
          <nav className="nav-desktop">
            <a href="#caracteristicas">Características</a>
            <a href="#historias">Historias</a>
            <a href="#precios">Precios</a>
            <a href="#preguntas">Preguntas</a>
            <button
              onClick={() => navigate('/login')}
              className="nav-link-login"
            >
              Iniciar Sesión
            </button>
            <button
              className="btn-call-header"
              onClick={() => setIsCallModalOpen(true)}
            >
              📞 Llamar ahora
            </button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="mobile-menu-btn"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? '✕' : '☰'}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <nav className="nav-mobile">
            <a href="#caracteristicas" onClick={() => setMobileMenuOpen(false)}>Características</a>
            <a href="#historias" onClick={() => setMobileMenuOpen(false)}>Historias</a>
            <a href="#precios" onClick={() => setMobileMenuOpen(false)}>Precios</a>
            <a href="#preguntas" onClick={() => setMobileMenuOpen(false)}>Preguntas</a>
            <button onClick={() => { setMobileMenuOpen(false); navigate('/login'); }}>
              Iniciar Sesión
            </button>
            <button
              className="btn-call-header"
              onClick={() => { setMobileMenuOpen(false); setIsCallModalOpen(true); }}
            >
              📞 Llamar ahora
            </button>
          </nav>
        )}
      </header>

      {/* ==================== CALL MODAL ==================== */}
      {isCallModalOpen && (
        <div className="modal-overlay" onClick={() => setIsCallModalOpen(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-icon">📞</div>
            <h3>Contáctanos</h3>
            <p className="modal-subtitle">Estamos aquí para ayudarte con cualquier consulta</p>

            <div className="modal-phone-box">
              <p className="modal-phone">{phoneNumber}</p>
              <p className="modal-hours">9:00 - 18:00</p>
            </div>

            <div className="modal-buttons">
              {isMobile ? (
                <a href={`tel:${cleanPhoneNumber}`} className="btn-modal-primary">
                  📞 Llamar ahora
                </a>
              ) : (
                <button onClick={handleCopyToClipboard} className="btn-modal-primary">
                  {copied ? '✓ ¡Copiado!' : '📋 Copiar número'}
                </button>
              )}
              <button onClick={() => setIsCallModalOpen(false)} className="btn-modal-secondary">
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}

        {/* ==================== VIDEO MODAL ==================== */}
        {isVideoModalOpen && (
          <div className="modal-overlay" onClick={() => setIsVideoModalOpen(false)}>
            <div className="modal-video-content" onClick={(e) => e.stopPropagation()}>
              <button
                className="modal-close-btn"
                onClick={() => setIsVideoModalOpen(false)}
              >
                ✕
              </button>
              <video
                src="/video-paquita.mp4"
                controls
                autoPlay
                style={{
                  width: '100%',
                  maxHeight: '80vh',
                  borderRadius: '12px'
               }}
             />
           </div>
        </div>
      )}

      {/* ==================== HERO SECTION ==================== */}
      <section className="hero">
        <div className="hero-content">
          <h1>
            Hable con <span className="highlight">Doña Paquita</span> y manténgase conectado con su familia
          </h1>
          <p>
            Una forma simple y cariñosa de mantener a su familia conectada mediante llamadas regulares con Doña Paquita.
          </p>
          <div className="hero-buttons">
            
              <a href="https://app.bentonico.ai/demo/"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-secondary"
            >
              Comenzar Demo
            </a>
            <button className="btn-primary" onClick={() => navigate('/login')}>
              Comenzar ahora
            </button>
          </div>
        </div>
        <div className="hero-image">
          <div className="hero-image-container">
            <img
              src="/familia.png"
              alt="Familia conectada"
              className="hero-img"
            />
          </div>
          <div
            className="video-badge"
            onClick={() => setIsVideoModalOpen(true)}
            style={{ cursor: 'pointer' }}
          >
            <div>▶ Doña Paquita</div>
            <small>Llamando ahora...</small>
          </div>
        </div>
      </section>

      {/* ==================== FEATURES ==================== */}
      <section className="features" id="caracteristicas">
        <h2>Manteniendo a las familias conectadas.</h2>
        <p className="features-subtitle">
          Descubra cómo Doña Paquita ayuda a fortalecer los lazos familiares con llamadas personalizadas y llenas de cariño.
        </p>

        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">⏰</div>
            <h3>Llamadas programadas</h3>
            <p>Doña Paquita llama en horarios convenientes para toda la familia.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">💜</div>
            <h3>Conversación personal</h3>
            <p>Las llamadas siempre son personales y cálidas, como hablar con una abuela.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">👥</div>
            <h3>Recibe llamadas</h3>
            <p>El abuelo puede llamar cuando lo estime oportuno.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">📅</div>
            <h3>Reporte diario</h3>
            <p>Doña Paquita reporta el estado de ánimo del abuelo a diario.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">📱</div>
            <h3>Tecnología simple</h3>
            <p>Fácil de usar para todas las generaciones, sin aplicaciones complicadas.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">⭐</div>
            <h3>Agente IA</h3>
            <p>Trabaja para cubrir la brecha digital.</p>
          </div>
        </div>
      </section>

      {/* ==================== TESTIMONIALS ==================== */}
      <section className="testimonials" id="historias">
        <div className="testimonials-container">
          <h2>Historias de familias conectadas</h2>
          <p className="testimonials-subtitle">
            Descubra cómo otras familias han fortalecido sus lazos con la ayuda de Doña Paquita.
          </p>

          <div className="testimonials-grid">
            <div className="testimonial-card">
              <div className="quote-icon">❝</div>
              <p className="testimonial-text">
                ¡Doña Paquita es como parte de nuestra familia ahora! Mis padres esperan su llamada cada semana.
              </p>
              <div className="testimonial-author">
                <div className="author-avatar">👩</div>
                <div className="author-info">
                  <h4>María Rodríguez</h4>
                  <p>Madre de 2 niños</p>
                </div>
              </div>
            </div>
            <div className="testimonial-card">
              <div className="quote-icon">❝</div>
              <p className="testimonial-text">
                Gracias a estas llamadas, mi abuela se siente más conectada con nosotros aunque vivamos lejos.
              </p>
              <div className="testimonial-author">
                <div className="author-avatar">👨</div>
                <div className="author-info">
                  <h4>Carlos Jiménez</h4>
                  <p>Profesional en el extranjero</p>
                </div>
              </div>
            </div>
            <div className="testimonial-card">
              <div className="quote-icon">❝</div>
              <p className="testimonial-text">
                Doña Paquita me da compañía durante el día, que se hace muy largo, ¡hablamos de todo!
              </p>
              <div className="testimonial-author">
                <div className="author-avatar">👵</div>
                <div className="author-info">
                  <h4>Ana López</h4>
                  <p>Abuela de 5 nietos</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ==================== TECHNOLOGY ==================== */}
      <section className="technology">
        <div className="tech-image">
          <div className="tech-image-container">
            <img
              src="/llamada.jpeg"
              alt="Tecnología simple"
              className="tech-img"
            />
          </div>
        </div>
        <div className="tech-content">
          <h2>Tecnología simple que une generaciones</h2>
          <p>
            No se requieren aplicaciones complicadas ni conocimientos técnicos. Doña Paquita llama
            directamente a su teléfono y a los de sus seres queridos, facilitando la comunicación
            entre todas las generaciones.
          </p>
          <div className="tech-features">
            <div className="tech-feature">
              <span className="check-icon">✓</span>
              <span>Sin aplicaciones para descargar</span>
            </div>
            <div className="tech-feature">
              <span className="check-icon">✓</span>
              <span>Funciona con cualquier teléfono</span>
            </div>
            <div className="tech-feature">
              <span className="check-icon">✓</span>
              <span>No requiere conocimientos técnicos</span>
            </div>
            <div className="tech-feature">
              <span className="check-icon">✓</span>
              <span>Reporte diario a familiar</span>
            </div>
          </div>
        </div>
      </section>

      {/* ==================== PRICING ==================== */}
      <section className="pricing" id="precios">
        <div className="pricing-container">
          <h2>Planes simples para todas las familias</h2>
          <p className="pricing-subtitle">
            Elija el plan que mejor se adapte a las necesidades de su familia. Sin contratos a largo plazo ni cargos ocultos.
          </p>

          <div className="pricing-grid">
            <div className="pricing-card">
              <h3>Plan Básico</h3>
              <p className="pricing-description">Ideal para mantener el contacto básico con la familia</p>
              <div className="price">
                <span className="price-amount">4,99</span>
                <span className="price-currency">€</span>
                <span className="price-period">/mes</span>
              </div>
              <ul className="pricing-features">
                <li><span className="check">✓</span> Chat con Doña Paquita</li>
                <li><span className="check">✓</span> Reporte básico diario</li>
                <li><span className="check">✓</span> Aviso de incidencias</li>
                <li><span className="check">✓</span> Realización de tareas (coming soon)</li>
              </ul>
              <button className="btn-pricing secondary" onClick={() => navigate('/login?plan=basico')}>
                Comenzar con Básico
              </button>
            </div>

            <div className="pricing-card featured">
              <div className="popular-badge">Más popular</div>
              <h3>Plan Premium</h3>
              <p className="pricing-description">La opción preferida para familias conectadas</p>
              <div className="price">
                <span className="price-amount">25</span>
                <span className="price-currency">€</span>
                <span className="price-period">/mes</span>
              </div>
              <ul className="pricing-features">
                <li><span className="check">✓</span> Llamada diaria</li>
                <li><span className="check">✓</span> Reporte pro</li>
                <li><span className="check">✓</span> Detección soledad no deseada</li>
                <li><span className="check">✓</span> Aviso incidencias</li>
                <li><span className="check">✓</span> Realización de tareas (coming soon)</li>
              </ul>
              <button className="btn-pricing primary" onClick={() => navigate('/login?plan=premium')}>
                Elegir Plan Premium
              </button>
            </div>

            <div className="pricing-card">
              <h3>Plan Buddy</h3>
              <p className="pricing-description">Comunicación completa para grandes familias</p>
              <div className="price">
                <span className="price-amount">99</span>
                <span className="price-currency">€</span>
                <span className="price-period">/mes</span>
              </div>
              <ul className="pricing-features">
                <li><span className="check">✓</span> Llamadas diaria</li>
                <li><span className="check">✓</span> Reporte premium</li>
                <li><span className="check">✓</span> Detección soledad no deseada</li>
                <li><span className="check">✓</span> Aviso incidencias</li>
                <li><span className="check">✓</span> Función mejora cognitiva</li>
                <li><span className="check">✓</span> Entrenamiento</li>
                <li><span className="check">✓</span> Realización de tareas (coming soon)</li>
              </ul>
              <button className="btn-pricing secondary" onClick={() => navigate('/login?plan=buddy')}>
                Obtener Paquita Buddy
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* ==================== FAQ ==================== */}
      <section className="faq" id="preguntas">
        <h2>Preguntas frecuentes</h2>
        <p className="faq-subtitle">Respuestas a las preguntas más comunes sobre nuestro servicio.</p>

        <div className="faq-item" onClick={() => toggleFaq(0)}>
          <div className="faq-question">
            <span>¿Quién es Doña Paquita?</span>
            <span>{activeFaq === 0 ? '↑' : '↓'}</span>
          </div>
          {activeFaq === 0 && (
            <div className="faq-answer">
              Doña Paquita es el primer agente de inteligencia artificial para detectar soledad no deseada
              a través de conversaciones telefónicas realizando llamadas regulares a los abuelos y reportando
              a la familia sobre su estado de ánimo.
            </div>
          )}
        </div>

        <div className="faq-item" onClick={() => toggleFaq(1)}>
          <div className="faq-question">
            <span>¿Cómo funcionan las llamadas?</span>
            <span>{activeFaq === 1 ? '↑' : '↓'}</span>
          </div>
          {activeFaq === 1 && (
            <div className="faq-answer">
              Las llamadas son automáticas y programadas según las preferencias de cada familia.
            </div>
          )}
        </div>

        <div className="faq-item" onClick={() => toggleFaq(2)}>
          <div className="faq-question">
            <span>¿Puedo personalizar al agente?</span>
            <span>{activeFaq === 2 ? '↑' : '↓'}</span>
          </div>
          {activeFaq === 2 && (
            <div className="faq-answer">
              Sí, puedes personalizar aspectos de las conversaciones y horarios de llamada.
            </div>
          )}
        </div>
      </section>

      {/* ==================== CTA ==================== */}
      <section className="cta">
        <h2>Mantenga a su familia conectada con Doña Paquita</h2>
        <p>Comience hoy y descubra cómo las llamadas regulares pueden fortalecer los lazos familiares de manera significativa.</p>
        
          <a href="https://app.bentonico.ai/demo/"
          target="_blank"
          rel="noopener noreferrer"
          className="btn-cta"
        >
          Comenzar demo →
        </a>
      </section>

      {/* ==================== FOOTER MEJORADO ==================== */}
      <footer className="footer-new">
        <div className="footer-container-new">
          <div className="footer-brand-new">
            <div className="footer-logo">
              <span className="logo-dona">Doña</span>
              <span className="logo-paquita">Paquita</span>
            </div>
            <p>Manteniendo a las familias conectadas a través de llamadas personales y llenas de cariño.</p>
            <div className="social-links-new">
              <a href="https://www.linkedin.com/company/bent%C3%B3nico/" target="_blank" rel="noopener noreferrer">
                LinkedIn
              </a>
              <a href="https://www.instagram.com/soyabuelapaquita/" target="_blank" rel="noopener noreferrer">
                Instagram
              </a>
              <a href="https://www.tiktok.com/@soyabuelapaquita" target="_blank" rel="noopener noreferrer">
                TikTok
              </a>
            </div>
          </div>

          <div className="footer-column-new">
            <h4>Servicios</h4>
            <ul>
              <li><button onClick={() => navigate('/login?plan=basico')}>Plan Básico</button></li>
              <li><button onClick={() => navigate('/login?plan=premium')}>Plan Premium</button></li>
              <li><button onClick={() => navigate('/login?plan=buddy')}>Plan Buddy</button></li>
            </ul>
          </div>

          <div className="footer-column-new">
            <h4>Nosotros</h4>
            <ul>
              <li>
                <a href="https://www.antena3.com/noticias/sociedad/dona-paquita-robot-que-acompana-mayores-residencia_20250606684310d869892f403368f2be.html" target="_blank" rel="noopener noreferrer">
                  Prensa
                </a>
              </li>
            </ul>
          </div>

          <div className="footer-column-new">
            <h4>Contacto</h4>
            <ul>
              <li>
                <a href="mailto:avatar@bentonico.ai">✉ avatar@bentonico.ai</a>
              </li>
              <li>
                <a href="tel:+34919931923">📞 +34 919 931 923</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© 2025 Bentonico. Todos los derechos reservados.</p>
          <div className="footer-legal">
            <a href="#">Términos de Servicio</a>
            <a href="#">Política de Privacidad</a>
          </div>
        </div>
      </footer>
      <PromoPopup />


    </div>
  );
};

export default Landing;
